import { Navigate, Outlet } from 'react-router-dom';
import { routes } from '../constants/strings/routes';
import { useBillingWriteAccess } from '../hooks/use-billing-write-access';

/**
 * Pathless layout-route guard. Nested write-only routes render through the
 * <Outlet /> only for Billing Write users; read-only users are redirected to
 * the billing home (matching the existing catch-all redirect convention).
 */
export const RequireBillingWrite = (): JSX.Element =>
  useBillingWriteAccess() ? (
    <Outlet />
  ) : (
    <Navigate replace to={routes.billing.home} />
  );
